import {
  cryptoJSAesEncrypt as aesSecureEncrypt,
  cryptoJSAesDecrypt as aesSecureDecrypt,
  getSecureRSAPrivateKey,
  getSecureRSAPublicKey
} from './secureAES.js'

import CryptoJS from 'crypto-js'
import { KJUR, KEYUTIL, hextob64} from 'jsrsasign'
import JSEncrypt from 'jsencrypt';

export function cryptoJSAesEncrypt(str = '', key = null, iv = null) {
  // 如果没有提供自定义密钥，使用安全的加密方案
  if (!key || !iv) {
    return aesSecureEncrypt(str)
  }

  const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(str), CryptoJS.enc.Utf8.parse(key), {
    iv: CryptoJS.enc.Utf8.parse(iv)
  })

  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}

export function cryptoJSAesDecrypt(str = '', key = null, iv = null) {
  // 如果没有提供自定义密钥，使用安全的解密方案
  if (!key || !iv) {
    return aesSecureDecrypt(str)
  }

  if (str) {
    const decrypt = CryptoJS.AES.decrypt(str, CryptoJS.enc.Utf8.parse(key), {
      iv: CryptoJS.enc.Utf8.parse(iv)
    })

    return CryptoJS.enc.Utf8.stringify(decrypt).toString()
  }
  return ''
}

export function cryptoJSAesEncryptWithoutIV(str = '') {
  const encrypted = CryptoJS.AES.encrypt(str, 'ceS5hfBr+98PvWxMpUeDog==')
  return encrypted.toString()
}

export function strToAsterisk(str = '') {
  if (!str) { return '' }

  const strLen = str.length
  if (strLen === 0) { return '' }

  let strPrefix; let strSuffix = ''

  if (strLen === 1) {
    strPrefix = str[0]
    strSuffix = str[0]
  }

  if (strLen === 2) {
    strPrefix = str.slice(0, 2)
    strSuffix = str.slice(strLen - 2, strLen)
  }

  if (strLen >= 3) {
    strPrefix = str.slice(0, 3)
    strSuffix = str.slice(strLen - 3, strLen)
  }

  return strPrefix + '***' + strSuffix
}

export function strEmailToAsterisk(str = '') {
  if (!str) { return '' }
  const strArr = str.split('@')

  if (strArr.length < 2) {
    return ''
  }
  const strStart = strArr[0]
  const strStartlength = strStart.length

  let strPrefix = ''
  if (strStartlength === 1) {
    strPrefix = str[0]
  }

  if (strStartlength >= 2) {
    strPrefix = str.slice(0, 2)
  }

  return strPrefix + '***@' + strArr[1]
}

export function strAesDecryptAndAsterisk(str = '') {
  const decrypt = cryptoJSAesDecrypt(str)
  return strToAsterisk(decrypt)
}

export function strAesDecryptAndAsteriskSameLength(str = '') {
  const decrypt = cryptoJSAesDecrypt(str)
  return strToStarSameLength(decrypt)
}

export function strAesDecryptAndEmailAsterisk(str = '') {
  const decrypt = cryptoJSAesDecrypt(str)
  return strEmailToAsterisk(decrypt)
}

export function randomStr(num) {
  const str = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
  let res = ''
  for (let i = 0; i < num; i++) {
    const id = Math.ceil(Math.random() * 61)
    res += str[id]
  }
  return res
}

export function strToStarSameLength(str) {
  if (!str) {
    return
  }

  const length = str.length
  if (length === 1) {
    return str + '***'
  }
  if (length === 2) {
    return str + '*'
  }
  if (length > 2 && length < 7) {
    let middle = ''
    const start = str.substring(0, 2)
    const end = str.substring(length - 1)
    for (let i = 2; i < length - 1; i++) {
      middle = middle + '*'
    }
    return start + middle + end
  }
  if (length > 7) {
    const start = str.substring(0, 3)
    const end = str.substring(length - 3)
    let middle = ''
    for (let i = 3; i < length - 3; i++) {
      middle = middle + '*'
    }
    return start + middle + end
  }
}
export function rsaEncrypt(needData) {
  let publicPEM = getSecureRSAPublicKey();
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicPEM); // 设置公钥
  const encrypted = encryptor.encrypt(needData); // 加密数据
  if (!encrypted) {
    throw new Error('加密失败，请检查公钥格式');
  }
  return encrypted; // 返回 Base64 编码的加密结果
}


export function rsaSign(needData){
  let privateKey = getSecureRSAPrivateKey();
  const key = KEYUTIL.getKey(privateKey);
  const signature = new KJUR.crypto.Signature({
    alg: "SHA256withRSA"
  })
  signature.init(key)
  signature.updateString(needData);
  const originSign = signature.sign();
  const baseString = hextob64(originSign)
  return baseString
}

export function generateRandomString(length = 16) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters[randomIndex];
  }
  return result;
}

